import PropTypes from 'prop-types';
import { sanitize } from 'dompurify';
import { Link } from 'react-router-dom';
import { EventIcons } from 'sportsbook-components';

import { Icon } from 'bv-components';

import MarketContainer from './market_container';

const Event = ({
  id, componentId, eventHref, fullDescription, market, metadata, eventMarketsCount,
}) => (
  <div className={`coupon-wrapper event-${id}`}>
    <Link className="bvs-card__header coupon-header" to={eventHref}>
      <h3 className="coupon-header-title" dangerouslySetInnerHTML={{ __html: sanitize(fullDescription) }} />
      <div className="coupon-header-subtitle">
        <div className="coupon-header-subtitle__text">{market.des}</div>
        <div className="coupon-header-icons">
          {metadata && <EventIcons {...metadata} />}
        </div>
        <div className="coupon-header-total">
          {eventMarketsCount}
          <Icon id="arrow-right" main />
        </div>
      </div>
    </Link>
    <MarketContainer
      componentId={componentId}
      {...market}
    />
  </div>
);

Event.propTypes = {
  id: PropTypes.number.isRequired,
  componentId: PropTypes.number.isRequired,
  meetingId: PropTypes.number.isRequired,
  fullDescription: PropTypes.string.isRequired,
  eventMarketsCount: PropTypes.number.isRequired,
  eventHref: PropTypes.string.isRequired,
  market: PropTypes.instanceOf(Object).isRequired,
  metadata: PropTypes.instanceOf(Object).isRequired,
};

export default Event;
